import { render } from "./ModalImportProduct.vue?vue&type=template&id=25406cb1"
import script from "./ModalImportProduct.vue?vue&type=script&lang=js"
export * from "./ModalImportProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__